import { Box } from '@freighthub/silhouette-core'
import { FC } from 'react'

import { IQuoteSheet } from '../QuoteSheetModel'
import { AdditionalServices } from './AdditionalServices'
import { OriginDestinationSection } from './OriginDestinationSection'
import { RequestInfo } from './RequestInfo'

type MainSectionProps = {
  quoteSheet: IQuoteSheet
  onEdit?: () => void
  editable?: boolean
}

export const MainSection: FC<MainSectionProps> = ({ onEdit, editable, quoteSheet }) => {
  return (
    <Box width="100%" height="100%">
      <RequestInfo quoteSheet={quoteSheet} />
      <OriginDestinationSection quoteSheet={quoteSheet} onEdit={onEdit} editable={editable} />
      <AdditionalServices quoteSheet={quoteSheet} />
    </Box>
  )
}
